const ONBOARDING_KEY = 'connectSports.pendingOnboarding';
const MAX_AGE_MS = 1000 * 60 * 60 * 24 * 7;

const canUseStorage = () => typeof window !== 'undefined' && !!window.localStorage;

export const setPendingOnboarding = (payload = {}) => {
    if (!canUseStorage()) {
        return;
    }

    const nextValue = {
        ...payload,
        createdAt: new Date().toISOString()
    };

    window.localStorage.setItem(ONBOARDING_KEY, JSON.stringify(nextValue));
};

export const getPendingOnboarding = () => {
    if (!canUseStorage()) {
        return null;
    }

    const rawValue = window.localStorage.getItem(ONBOARDING_KEY);
    if (!rawValue) {
        return null;
    }

    try {
        const parsed = JSON.parse(rawValue);
        const createdAt = parsed?.createdAt ? new Date(parsed.createdAt).getTime() : 0;

        if (!createdAt || Number.isNaN(createdAt) || Date.now() - createdAt > MAX_AGE_MS) {
            window.localStorage.removeItem(ONBOARDING_KEY);
            return null;
        }

        return parsed;
    } catch {
        window.localStorage.removeItem(ONBOARDING_KEY);
        return null;
    }
};

export const clearPendingOnboarding = () => {
    if (!canUseStorage()) {
        return;
    }

    window.localStorage.removeItem(ONBOARDING_KEY);
};
